import { render, staticRenderFns } from "./BSSignAgreement.vue?vue&type=template&id=07e62c42"
import script from "./BSSignAgreement.vue?vue&type=script&lang=js"
export * from "./BSSignAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports